import React from "react";
import { useParams, Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import Spinner from "react-bootstrap/Spinner";
import Top from "../../components/Top";
import { API_BASE_URL } from "../../api/config";
import "../../index.css";
import parse from "html-react-parser";

function CareerDetail() {
  const { id } = useParams();

  const { isLoading, isError, data, error } = useQuery({
    queryKey: ["career-listing", id],
    queryFn: async () => {
      const res = await fetch(
        `${API_BASE_URL}/api/user/career_listings/${id}`
      );
      return await res.json();
    },
  });

  if (isLoading) {
    return (
      <div
        className="d-flex flex-column justify-content-center align-items-center"
        style={{ height: "50vh" }}
      >
        <Spinner
          animation="border"
          role="status"
          style={{ height: "89px", width: "89px" }}
        >
          <span className="visually-hidden">Loading...</span>
        </Spinner>
        <p className="mt-3">Kindly be patient while we fetch your data</p>
      </div>
    );
  }

  if (isError) {
    return <p>An Error Occurred: {error.message}</p>;
  }

  return (
    <div className="career-detail-page">
      <div className="container career-detail-content">
        <Link to="/careers" className="career-back-link">
          ← Back to Careers
        </Link>
        <div className="career-detail-header">
          <h3>{data?.title}</h3>
          <div className="career-detail-meta">
            {data?.department && (
              <span className="career-tag">
                <i className="fas fa-building"></i> {data.department}
              </span>
            )}
            <span className="career-tag">
              <i className="fas fa-map-marker-alt"></i> {data?.location}
            </span>
            <span className="career-tag">
              <i className="fas fa-briefcase"></i> {data?.employment_type}
            </span>
            <span className="career-tag">
              <i className="fas fa-laptop-house"></i> {data?.work_mode}
            </span>
            {data?.experience_level && (
              <span className="career-tag">
                <i className="fas fa-chart-line"></i> {data.experience_level}
              </span>
            )}
            {data?.salary_range && (
              <span className="career-tag">
                <i className="fas fa-money-bill-wave"></i> {data.salary_range}
              </span>
            )}
          </div>
          {data?.application_deadline && (
            <p className="career-deadline mt-3">
              <i className="fas fa-calendar-alt"></i> Application Deadline:{" "}
              {new Date(data.application_deadline).toLocaleDateString()}
            </p>
          )}
        </div>

        {data?.summary && (
          <div className="career-section">
            <p className="career-summary-text">{data.summary}</p>
          </div>
        )}

        {data?.description && (
          <div className="career-section">
            <h5>Description</h5>
            <div>{parse(data.description)}</div>
          </div>
        )}

        {data?.responsibilities && (
          <div className="career-section">
            <h5>Responsibilities</h5>
            <div>{parse(data.responsibilities)}</div>
          </div>
        )}

        {data?.requirements && (
          <div className="career-section">
            <h5>Requirements</h5>
            <div>{parse(data.requirements)}</div>
          </div>
        )}

        {data?.benefits && (
          <div className="career-section">
            <h5>Benefits</h5>
            <div>{parse(data.benefits)}</div>
          </div>
        )}

        <div className="career-apply-section">
          <h5>How to Apply</h5>
          {data?.application_email && (
            <p>
              Send your resume to{" "}
              <a href={`mailto:${data.application_email}`}>
                {data.application_email}
              </a>
            </p>
          )}
          {data?.application_url && (
            <a
              href={data.application_url}
              target="_blank"
              rel="noreferrer"
              className="career-apply-btn"
            >
              Apply Now
            </a>
          )}
          {!data?.application_email && !data?.application_url && (
            <p>
              Please send your resume to{" "}
              <a href="mailto:support@aaerlaw.com">support@aaerlaw.com</a>
            </p>
          )}
        </div>
      </div>
      <Top />
    </div>
  );
}

export default CareerDetail;
